const SERVICE_UUID = 0x01FF;
//蓝牙特征值
const commonInfo = {
    firmware: 0x1A01,
    hardware: 0x1A02,
    model: 0x1A03,
    name: 0x1A04,
    MAC: 0x1A05,
    MCU: 0x1A06
}
// 在文件顶部添加 MQTT 特征值常量
const MQTT_CONFIG = {
    CLIENT_ID_UUID: 0x0300,
    HOST_UUID: 0x0301,
    PORT_UUID: 0x0302,
    USER_UUID: 0x0303,
    PASSWORD_UUID: 0x0304,
    QOS_UUID: 0x0305,
    CONNECT_CMD_UUID: 0x0306,
    STATUS_UUID: 0x0307
};
const characInfo = {
    ledSwitch: 0x0201,         // 开关
    ledBrightness: 0x0202,     // 亮度
    ledFlashOnce: 0x0203,      // 闪光灯
    lightIntensity: 0x0204,    // 光强
    pirStatus: 0x0205,         // 人体感应器状态
    temperature: 0x0206,       // 温度
    humidity: 0x0207,          // 湿度
    music: 0x0208,             // 音乐
    recordControl:0x0209,      // 录音控制
    keyEve: 0x0205,              // 按键1
    // key1: 0x020A,              // 按键1
    // key2: 0x020B,              // 按键2
    // key3: 0x020C,              // 按键3
    rollAngle: 0x0210,         // 横滚角
    pitchAngle: 0x0211,        // 俯仰角
    yawAngle: 0x0212,          // 偏航角
    acceleration: 0x0213,      // 加速度（x轴，y轴，z轴）
    gyroscope: 0x0214,         // 角速度（x轴，y轴，z轴）
    magnetometer: 0x0215,      // 三轴磁力计值
    beepFreq: 0x0216,          // 蜂鸣器频率
    beepSwitch: 0x0201,         // 蜂鸣器开关
    h1Mode: 0x0218,
    h1Duty: 0x0219,
    h1Frequency: 0x0220,
    decibel: 0x0221,           // 分贝大小
    threeLights: 0x0201,       // 三色灯
    crash: 0x0223,
    gesture: 0x0224,
    usbSwitch: 0x0201,
    command: 0x0230, //命令序号
    signalStrength:  0x0231, //信号强度
    IMEI: 0x0232,//4G模块信号强度
    operator: 0x0233,//运营商
    iccid:0x0234,
    simId:0x0235,
    recv5GData:0x0236,
    status5G:0x0237,
    mqtt_clientId: 0x023D,
    mqtt_host: 0x023E,
    mqtt_port: 0x023F,
    mqtt_connect: 0x0238,
    mqtt_user: 0x0239,
    mqtt_pwd: 0x023A,
    mqtt_qos: 0x023B,
    mqtt_topic: 0x023C,
    mqtt_publish: 0x0240,
    mqtt_subscribe: 0x0241,
    mqtt_state: 0x0242,
    distance:0x0223,
    programme:0X0240,
    satelilitesNo: 0x0243,
    beidouSatellitesNo:0x0244,
    gpsSatellitesNo:0x0245,
    speed: 0x0247,
    angleOfMotion: 0x0248,
    gps_acceleration:0x0249,
    gps_time:0x024A,
    positionStatus:0x024B,
    altitude:0x024C,
    lon: 0x024E,//GPS定位信息
    lat: 0x024D,





    
}

export const BLE_CONFIG = {
    SERVICE_UUID: SERVICE_UUID,
    ...commonInfo,
    ...characInfo 
}